import React from 'react';

export const NotFoundSvg = () => (
    <svg
        width="228"
        height="160"
        viewBox="0 0 228 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="35" width="160" height="160" rx="10" fill="#E9ECF1" />
        <g filter="url(#filter0_d_248_27299)">
            <rect x="35" y="32" width="102" height="16" rx="4" fill="white" />
        </g>
        <g filter="url(#filter1_d_248_27299)">
            <rect x="4" y="16" width="133" height="32" rx="4" fill="white" />
        </g>
        <g filter="url(#filter2_d_248_27299)">
            <rect x="93" y="80" width="102" height="16" rx="4" fill="white" />
        </g>
        <g filter="url(#filter3_d_248_27299)">
            <rect x="91" y="64" width="133" height="32" rx="4" fill="white" />
        </g>
        <g filter="url(#filter4_d_248_27299)">
            <rect x="38" y="128" width="99" height="16" rx="4" fill="white" />
        </g>
        <g filter="url(#filter5_d_248_27299)">
            <rect x="4" y="112" width="133" height="32" rx="4" fill="white" />
        </g>
        <rect x="10" y="21" width="22" height="22" rx="4" fill="#7787A6" />
        <rect x="97" y="69" width="22" height="22" rx="4" fill="#7787A6" />
        <rect x="10" y="117" width="22" height="22" rx="4" fill="#7787A6" />
        <rect x="40" y="22" width="62" height="8" rx="4" fill="#9DA9BF" />
        <rect x="127" y="70" width="62" height="8" rx="4" fill="#9DA9BF" />
        <rect x="40" y="118" width="62" height="8" rx="4" fill="#9DA9BF" />
        <rect
            x="40.5"
            y="34.5"
            width="37"
            height="7"
            rx="3.5"
            fill="#C4CBD8"
            stroke="#D7D7D7"
        />
        <rect
            x="127.5"
            y="82.5"
            width="37"
            height="7"
            rx="3.5"
            fill="#C4CBD8"
            stroke="#D7D7D7"
        />
        <rect
            x="40.5"
            y="130.5"
            width="37"
            height="7"
            rx="3.5"
            fill="#C4CBD8"
            stroke="#D7D7D7"
        />
        <defs>
            <filter
                id="filter0_d_248_27299"
                x="27"
                y="26"
                width="118"
                height="32"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.698039 0 0 0 0 0.737255 0 0 0 0 0.811765 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_248_27299"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_248_27299"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_248_27299"
                x="0"
                y="14"
                width="141"
                height="40"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.2 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_248_27299"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_248_27299"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_248_27299"
                x="85"
                y="74"
                width="118"
                height="32"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.698039 0 0 0 0 0.737255 0 0 0 0 0.811765 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_248_27299"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_248_27299"
                    result="shape"
                />
            </filter>
            <filter
                id="filter3_d_248_27299"
                x="87"
                y="62"
                width="141"
                height="40"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.2 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_248_27299"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_248_27299"
                    result="shape"
                />
            </filter>
            <filter
                id="filter4_d_248_27299"
                x="30"
                y="122"
                width="115"
                height="32"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.698039 0 0 0 0 0.737255 0 0 0 0 0.811765 0 0 0 1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_248_27299"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_248_27299"
                    result="shape"
                />
            </filter>
            <filter
                id="filter5_d_248_27299"
                x="0"
                y="110"
                width="141"
                height="40"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.698039 0 0 0 0 0.737255 0 0 0 0 0.811765 0 0 0 0.3 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_248_27299"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_248_27299"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);
